import React from 'react';
import NewProjectWizardCard from './NewProjectWizardCard';
import styles from './css/index.module.css';
import checkIcon from './assets/check.svg';

const SetupProjectReady = ({ workstreamCount = 0, folderCount = 0, requestCount = 0, onEnter, onSetupTeam }) => {
    const items = [
        'Project context established',
        `${workstreamCount} workstream${workstreamCount === 1 ? '' : 's'} configured`,
        'VDR structure created',
        'Initial IRL created',
    ];

    return (
        <NewProjectWizardCard step={4} totalSteps={4} title="Project ready" hideFooter>
            <div className={styles.readyBody}>
                <ul className={styles.readyList}>
                    {items.map(label => (
                        <li key={label} className={styles.readyItem}>
                            <span className={`${styles.preparingIcon} ${styles.preparingIconDone}`} aria-hidden="true">
                                <img src={checkIcon} alt="" width={10} height={8} className={styles.preparingCheck} />
                            </span>
                            <span className={styles.readyLabel}>{label}</span>
                        </li>
                    ))}
                </ul>

                <div className={styles.readyStats}>
                    <div className={styles.readyStat}>
                        <p className={styles.readyStatValue}>{workstreamCount}</p>
                        <p className={styles.readyStatLabel}>workstreams</p>
                    </div>
                    <div className={styles.readyStat}>
                        <p className={styles.readyStatValue}>{folderCount}</p>
                        <p className={styles.readyStatLabel}>VDR folders</p>
                    </div>
                    <div className={styles.readyStat}>
                        <p className={styles.readyStatValue}>{requestCount}</p>
                        <p className={styles.readyStatLabel}>initial IRL requests</p>
                    </div>
                </div>

                <button type="button" className={`${styles.primaryButton} ${styles.readyEnter}`} onClick={onEnter}>
                    Enter project
                </button>
                <button type="button" className={`${styles.ghostButton} ${styles.readyTeamLink}`} onClick={onSetupTeam}>
                    Set up team & access
                </button>
            </div>
        </NewProjectWizardCard>
    );
};

export default SetupProjectReady;
